module.exports = __webpack_public_path__ + "static/media/rd_martinov_(2).fd689e37.jpg";